import WebSocket from "isomorphic-ws";
import { defer } from "./Deferred.mjs";
export const isMessage = (m) => typeof m[0] === 'string';
export const asMessage = (m) => isMessage(m) ? m : m[1];
export class Socket {
    constructor(url, opts) {
        this.opts = opts;
        this.failedToConnect = false;
        this.onOpen = () => {
            this.ready.resolve();
            this.opts.onOpen();
        };
        this.onClose = () => {
            this.ready.reject();
            this.opts.onClose();
            if (this.ws) {
                this._close();
            }
        };
        this.onError = () => {
            this.ready.reject();
            this.opts.onError();
            this._close();
        };
        this.onMessage = (event) => {
            try {
                this.opts.onMessage(JSON.parse(event.data));
            }
            catch (e) {
                // pass
            }
        };
        this.send = (message) => {
            if (!this.ws) {
                throw new Error('Send attempted before socket was opened');
            }
            this.ws.send(JSON.stringify(message));
        };
        this.connect = () => {
            if (this.ws) {
                throw new Error(`Already attempted connection for ${this.url}`);
            }
            try {
                this.ws = new WebSocket(this.url);
                this.ws.onopen = this.onOpen;
                this.ws.onclose = this.onClose;
                this.ws.onerror = this.onError;
                this.ws.onmessage = this.onMessage;
            }
            catch (e) {
                this.failedToConnect = true;
            }
        };
        this.url = url;
        this.ready = defer();
    }
    _close() {
        if (!this.ws) {
            throw new Error('Socket was closed before it was opened');
        }
        // Avoid "WebSocket was closed before the connection was established"
        this.ready.then(() => { var _a; return (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close(); }).catch(() => null);
    }
    isPending() {
        return !this.ws && !this.failedToConnect;
    }
    isConnecting() {
        var _a;
        return ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.CONNECTING;
    }
    isReady() {
        var _a;
        return ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN;
    }
    isClosing() {
        var _a;
        return ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.CLOSING;
    }
    isClosed() {
        var _a;
        return ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.CLOSED;
    }
    isHealthy() {
        return this.isPending() || this.isConnecting() || this.isReady();
    }
    disconnect() {
        this.onClose();
    }
    reset() {
        if (this.ws) {
            this._close();
        }
        this.ws = undefined;
        this.ready = defer();
    }
}
//# sourceMappingURL=Socket.mjs.map